import { render, staticRenderFns } from "./changeOrderInfo.vue?vue&type=template&id=873250fe&scoped=true&"
import script from "./changeOrderInfo.vue?vue&type=script&lang=js&"
export * from "./changeOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./changeOrderInfo.vue?vue&type=style&index=0&id=873250fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873250fe",
  null
  
)

export default component.exports